import dev.shanty.kotwire.stimulus.Controller
import dev.shanty.kotwire.stimulus.StimulusController
import kotlinx.browser.window
import org.w3c.dom.HTMLInputElement
import org.w3c.dom.events.Event

@JsExport
@StimulusController(targets = ["name", "quantity", "notes"])
class PackingFormController(context: dynamic) : Controller(context) {
    private val name by nameTarget<HTMLInputElement>()
    private val quantity by quantityTarget<HTMLInputElement>()
    private val notes by notesTarget<HTMLInputElement>()

    @JsName("reset")
    fun reset(event: Event) {
        val success = event.asDynamic().detail?.success as? Boolean ?: false
        if (!success) return

        name.value = ""
        quantity.value = "1"
        notes.value = ""
        window.setTimeout({
            element.asDynamic().scrollIntoView(js("{ behavior: 'smooth', block: 'center' }"))
            name.asDynamic().focus(js("{ preventScroll: true }"))
        }, 50)
    }
}
